import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { FilterModel } from '../common/model/ui/filter.model';
import { withFilterLookupOptions } from '../common/utils/services/list-filter-utils';
import { UserInfoFields } from '../firebase/document-field.enums';
import UserService from '../services/user.service';

export function useUserListFilters(filters: FilterModel[]): FilterModel[] {
  const { t } = useTranslation();
  const noneOption = { label: t('common.values.none'), value: 'None' };

  const roles = useQuery({
    queryKey: ['admin-users-roles-search-filters'],
    queryFn: () => UserService.loadAllUserRoles(),
    retry: 0,
  });
  const disorders = useQuery({
    queryKey: ['admin-users-fertility-search-filters'],
    queryFn: () => UserService.loadAllFertilityDisorders(),
    select: (data) =>
      data.map(
        ({ known_reproductive_disorder }) => known_reproductive_disorder
      ),
    retry: 0,
  });

  return withFilterLookupOptions(filters, {
    [UserInfoFields.roles]: {
      query: roles,
      fixedOptions: [noneOption],
    },
    [UserInfoFields.known_reproductive_disorder]: {
      query: disorders,
      fixedOptions: [noneOption],
    },
  });
}
